import {defineStore} from "pinia";
import {StorageSerializers, useStorage} from "@vueuse/core";
import {ref} from "vue";
import BidPackageCompanyFileAPI from "@/api/BidPackageCompanyFileAPI";
import {createRequestDeduper} from '@/use/createRequestDeduper';

export const useBidPackageCompanyFileStore = defineStore('bid-package-company-files', () => {

  const bidPackageCompanyFiles = useStorage('bidPackageCompanyFiles', null, sessionStorage, {
    serializer: StorageSerializers.object,
  });
  const isLoading = ref<boolean>(false);
  const dedupeRequest = createRequestDeduper();
  let activeIndexKey: string | null = null;

  const clear = () => {
    activeIndexKey = null;
    bidPackageCompanyFiles.value = null;
    isLoading.value = false;
  };

  const index = async (projectId: number, bidPackageId: number, payload: any = { params: null}) => {
    const { params } = payload;
    const key = `bid-package-company-files:${projectId}:${bidPackageId}:${JSON.stringify(params)}`;
    activeIndexKey = key;
    bidPackageCompanyFiles.value = null;

    return dedupeRequest(key, async () => {
      isLoading.value = true;
      const data = await new BidPackageCompanyFileAPI().index(projectId, bidPackageId, params)
        .finally(() => {
          if (activeIndexKey === key) {
            isLoading.value = false;
          }
        });

      if (activeIndexKey === key) {
        bidPackageCompanyFiles.value = data;
      }
    });
  };

  const store = async (data: any) => {

    const { params, ...rest } = data;

    isLoading.value = true;
    return await new BidPackageCompanyFileAPI().store(params.projectId, params.bidPackageId, rest)
        .then(data => {
          return data;
        })
        .finally(() => isLoading.value = false);
  };

  return {
    bidPackageCompanyFiles,
    isLoading,
    clear,
    index,
    store,
  };
});
